import React from "react";
import { QA } from "reducers/QA";

import FilterHeader from "utils/columns/FilterHeader";

import DateCell from "../cells/DateColumn";
import QAPanelName from "../cells/QAName";
import QAActions from "../cells/QAActions";
import SelectCell from "../cells/SelectCell";


export const QA_COLUMNS = [
	{
		...SelectCell,
		locked: false,
		getRowMetaData(data){
			return {
				type:"qa",
				checkboxId:data.id,
				id:data.id,
				isSelected: data.isSelected || false,
			};
		},
	},
	QAPanelName,
	 {
		key: "id",
		name: "ID",
		className:"id-cell",
		cellClass:"cypress-qa-id",
		width:80,
		resizable:false,
		sortable:true,
	},
	QAActions,
	{
		...DateCell,
		name:"Submitted Date",
		key:"oldestSubmitDate",
		cellClass:"cypress-qa-submitted-date",
	}, {
		key: "submitted",
		name: "Submitted",
		width:110,
		cellClass:"cypress-qa-submitted",
		resizable:false,
		sortable:true,
	},
	{
		key: "pendingApproval",
		name: "Approving",
		width:110,
		cellClass:"cypress-qa-approving",
		resizable:false,
		sortable:true,
	},
	{
		key: "qaLocationId",
		name: "Department",
		width:120,
		cellClass:"cypress-qa-department",
		resizable:false,
		sortable:true,
		getRowMetaData(data){
			return { ...data?.department };
		},
		formatter({ dependentValues }){ return dependentValues.label || ""; },
		headerRenderer: (
			<FilterHeader
				Reducer = {QA}
				filterSelector = {state => state.qa.columnFilters.active.qaLocationId}
			/>
		),
	},
	{
		key: "submittedBy",
		name: "Submitted By",
		cellClass:"cypress-qa-submitted",
		resizable:true,
		sortable:true,
		headerRenderer: (
			<FilterHeader
				Reducer = {QA}
				filterSelector = {state => state.qa.columnFilters.active.submittedBy}
			/>
		),
	},
	{
		key: "assignee",
		name: "Assigned To",
		cellClass:"cypress-qa-assigned",
		resizable:true,
		sortable:true,
	},
];
